// extracted by mini-css-extract-plugin
module.exports = {"btnModal":"ButtonModal_btnModal__3wOdB","btnModalHoverIcon":"ButtonModal_btnModalHoverIcon__3cCEZ","btnModalContenido":"ButtonModal_btnModalContenido__1Bza8"};